export default __webpack_public_path__ + "static/pulse-animation-77aeb605d48a50e1147bcb245118df6b.png";